import React from 'react';
import {getDescriber} from '../../descriptor/DescriptorType';
import Settings from '../../../../../Settings';
import AVText from '../../../../elements/AVText';
import Localized from '../../../../../constants/AppStrings';
import {getDescriber as getSnackDescriber} from '../../../sendSnack/descriptor/sendasnack/DescriptorType';
import {helpScreenStyles} from '../styles';

export const ContactSection: React.FC<{onContactClick: () => void}> = ({
  onContactClick,
}) => {
  const {getHelpStyleDescriptor} = getDescriber();
  const isRefiveOr365Pay = Settings.isRefiveAnd365Pay();

  return (
    <>
      <AVText
        style={getHelpStyleDescriptor(isRefiveOr365Pay)?.header}
        accessibilityRole="header"
        accessibilityLabel={Localized.Labels.contact_us}
      >
        {Localized.Labels.contact_us}
      </AVText>

      <AVText
        style={[
          getHelpStyleDescriptor(isRefiveOr365Pay)?.text,
          isRefiveOr365Pay ? helpScreenStyles.template1Style : null,
          getSnackDescriber().snackDetailsBtnFontSTyle(),
        ]}
        onPress={onContactClick}
        accessibilityRole="link"
        accessibilityHint="Double tap to send a message from your email client"
        accessible={true}
      >
        {Localized.Labels.formatString(
          Localized.Labels.contact_us_answer,
          <AVText
            style={[
              getHelpStyleDescriptor()?.link,
              isRefiveOr365Pay && !Settings.isAramark()
                ? helpScreenStyles.answersTxt
                : null,
              getSnackDescriber().snackDetailsBtnFontSTyle(),
            ]}
          >
            {Settings.supportEmail}
          </AVText>,
        )}
      </AVText>
    </>
  );
};
